import React, {useCallback, useContext, useEffect, useState} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Select, {SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import {PickFilterContext} from "./context/PickFilterContext";
import Tag from "@amzn/meridian/tag";
import {FormattedMessage, injectIntl} from "react-intl";
import Button from "@amzn/meridian/button";
import Popover, {PopoverHeader} from "@amzn/meridian/popover";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import * as PickColumns from "./PickTableColumns";
import ExportCSV from "../exportcsv/ExportCSV";
import {getPickDataInCSVFormat} from "../util/ExportUtils";
import {PickContext} from "./context/PickContext";
import {CapabilityContext} from "../global/context/CapabilityContext";

const PickFilterView = (props) => {
    const {viewModelF, dispatchF} = useContext(PickFilterContext)
    const [filterState, setFilterState] = useState(false);
    const {configViewModel} = useContext(CapabilityContext);
    const {viewModel} = useContext(PickContext);

    const [viewOptionVisible, setViewOptionVisible] = useState(false);
    const onClickViewOptionButton = useCallback(() => setViewOptionVisible(true), [])
    const onCloseViewOptionButton = useCallback(() => setViewOptionVisible(false), [])
    const optionButtonRef = React.useRef();

    const headersToStringId = [
        {value: 'pickStatus.stationPairs', header: PickColumns.STATION_PAIRS},
        {value: 'pickStatus.pick_by_time', header: PickColumns.PICK_BY_TIME},
        {value: 'pickStatus.routeId', header: PickColumns.ROUTE_ID},
        {value: 'pickStatus.status', header: PickColumns.STATUS},
        {value: 'pickStatus.carts', header: PickColumns.CARTS},
        {value: 'pickStatus.progress', header: PickColumns.PROGRESS},
        {value: 'pickStatus.associate', header: PickColumns.ASSOCIATE},
        {value: 'pickStatus.duration', header: PickColumns.DURATION},
        {value: 'pickStatus.type', header: PickColumns.TYPE}
    ];

    useEffect(() => {
        dispatchF({type: 'LOAD_PICK_COLUMNS', data: {capability: configViewModel.capability}});
    }, []);

    const setViewOptionColumns = (newValue) => {
        dispatchF({
            type: 'SET_PICK_COLUMNS', data: {
                newValue: newValue,
                capability: configViewModel.capability
            }
        });
    }

    const displayViewOptions = () => {
        var finalResult = [headersToStringId.map(entry => {
            if (entry.header === PickColumns.ROUTE_ID) {
                return <Checkbox disabled={true} value={entry.header}>
                    {props.intl.formatMessage({
                        id: entry.value,
                        defaultMessage: entry.header
                    })}
                </Checkbox>;
            }
            return <Checkbox value={entry.header}>
                {props.intl.formatMessage({
                    id: entry.value,
                    defaultMessage: entry.header
                })}
            </Checkbox>;
        })];
        return finalResult;
    }

    const toggleFilter = () => {
        setFilterState(!filterState);
    };

    const pickDataConversionHandler = () => {
        return getPickDataInCSVFormat(viewModel.routeList, configViewModel.capability, configViewModel.stationConfig);
    }

    const isFilterSet = () => {
        let result = false;
        Object.entries(viewModelF).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data' && key !== 'selectedPickColumns');
        });
        return result;
    }

    const clearAllFilters = () => {
        dispatchF({type: 'REMOVE_ALL_FILTER'});
    }

    const getFilterDropDownMenu = () => {
        return (
            <Column width="100%" spacingInset="medium large medium large" backgroundColor="secondary">
                <Row width="100%" spacing="none" spacingInset="none">
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="pickfilter.departure" defaultMessage="Departure"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DEPARTURE', Departure: data})}
                            value={viewModelF.departure}
                            size="small"
                            placeholder="Departure"
                            width={150}>
                            {[...viewModelF.data.departure].sort().map(departure => (
                                <SelectOption key={departure} label={"Departing " + departure}
                                              value={departure}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="pickfilter.driverType" defaultMessage="Driver Type"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                            value={viewModelF.driverType}
                            size="small"
                            placeholder="Driver Type"
                            width={150}>
                            {[...viewModelF.data.driverType].sort().map(driverType => (
                                <SelectOption key={driverType} label={driverType} value={driverType}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fill" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            <FormattedMessage id="pickfilter.cluster" defaultMessage="Cluster"/>
                        </Text>
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_CLUSTER', Cluster: data})}
                            value={viewModelF.cluster}
                            size="small"
                            placeholder="Cluster"
                            width={150}>
                            {[...viewModelF.data.cluster].sort().map(cluster => (
                                <SelectOption key={cluster} label={cluster} value={cluster}/>
                            ))}
                        </Select>
                    </Column>
                    <Column heights="fit" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            &nbsp;
                        </Text>
                        <Button data-test-id="viewOptionsBtn" type="tertiary" size="small" onClick={onClickViewOptionButton}
                                ref={optionButtonRef}>
                            <FormattedMessage id="pickfilter.viewOptions" defaultMessage="View Options"/>
                        </Button>
                        <Popover anchorNode={optionButtonRef.current} open={viewOptionVisible}
                                 onClose={onCloseViewOptionButton} position="right" alignment="center">
                            <PopoverHeader closeLabel="Close">
                                <FormattedMessage id="pickfilter.available_columns"
                                                  defaultMessage="Available Columns"/>
                            </PopoverHeader>
                            <div style={{"overflowX": "scroll", "maxHeight": "300px"}}>
                                <ControlGroup onChange={setViewOptionColumns}
                                              value={viewModelF.selectedPickColumns}>
                                    {
                                        displayViewOptions()
                                    }
                                </ControlGroup>
                            </div>
                        </Popover>
                    </Column>
                    <Column heights="fit" alignmentHorizontal="left" spacingInset="none small none">
                        <Text type="h100" alignment="left">
                            &nbsp;
                        </Text>
                        <ExportCSV csvDataProvider={pickDataConversionHandler} filePrefix={"PICK"}/>
                    </Column>
                </Row>
            </Column>
        )
    }

    return (
        <Column>
            <Row width="100%" spacing="large" spacingInset="medium large none large">
                <Link href="" type="secondary" onClick={toggleFilter}>Options</Link>
            </Row>
            {filterState ? getFilterDropDownMenu() : null}
            <Row width="100%" spacingInset="none large">
                <Row spacing={"small"}>
                    {Object.entries(viewModelF).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'data' && key !== 'selectedPickColumns') ?
                                values.map(value => {
                                    return <Tag key={value} type="neutral"
                                                onClose={() => dispatchF({
                                                    type: 'REMOVE_FILTER',
                                                    data: {key, value}
                                                })}>{value}</Tag>
                                }) : null
                        )
                    })}
                    {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">Clear all</Link> : null}
                </Row>
            </Row>
        </Column>
    )
}

export default injectIntl(PickFilterView);


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickFilterView.js